import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "name", "disabled"]
const _hoisted_2 = {
  key: 0,
  value: null,
  selected: "",
  disabled: "",
  hidden: "",
  "data-qa": "option-field-option-placeholder"
}
const _hoisted_3 = ["value", "data-qa"]
const _hoisted_4 = ["id", "value", "readonly", "name"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({ ..._ctx.$attrs, ..._ctx.$props })), _createSlots({
    label: _withCtx(() => [
      _renderSlot(_ctx.$slots, "label")
    ]),
    default: _withCtx(() => [
      (!_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass($options.selectWrapperClasses)
          }, [
            _withDirectives(_createElementVNode("select", {
              id: _ctx.fieldId,
              ref: "input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
              name: _ctx.name,
              disabled: _ctx.disabled,
              onChange: _cache[1] || (_cache[1] = (...args) => ($options.onChange && $options.onChange(...args))),
              "data-qa": "option-field-select"
            }, [
              ($props.showPlaceholder)
                ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString(_ctx.placeholder || _ctx.Resources.Common.PleaseSelectPlaceholder), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.optionsArray, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.name + option.value,
                  value: option.value,
                  "data-qa": `option-field-option:${option.value}`
                }, _toDisplayString(option.name), 9 /* TEXT, PROPS */, _hoisted_3))
              }), 128 /* KEYED_FRAGMENT */))
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1), [
              [_vModelSelect, _ctx.model]
            ])
          ], 2 /* CLASS */))
        : (_openBlock(), _createElementBlock("input", {
            key: 1,
            id: _ctx.fieldId,
            class: _normalizeClass(['gfu-field__input gfu-field__input--readonly', { 'gfu-field__input--small': _ctx.small }]),
            type: "text",
            value: $options.optionsArray.find(option => option.value === _ctx.model)?.name || $props.readOnlyPlaceholder,
            readonly: _ctx.readOnly,
            name: _ctx.name,
            "data-qa": "input-field"
          }, null, 10 /* CLASS, PROPS */, _hoisted_4)),
      _renderSlot(_ctx.$slots, "additional-field-info")
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots.tooltip)
      ? {
          name: "tooltip",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "tooltip")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots['field-description'])
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "field-description")
          ]),
          key: "1"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
}